import { render, staticRenderFns } from "./human_resource.vue?vue&type=template&id=ebc51a2a&"
import script from "./human_resource.vue?vue&type=script&lang=js&"
export * from "./human_resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports